module.exports = __webpack_public_path__ + "img/售后服务2ico.60cf2698.png";